module.exports = __webpack_public_path__ + "img/news2.ef75d746.png";